import { registerEvent } from '@/services/messaging/clientEventMethods';

export const checkoutSuccessful$ = registerEvent("CheckoutSuccessfulEvent");
